import { fetchDataPromise } from '../index';

// account manager
export const getAccountDetail = (resolve, reject, token, accountSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/getaccountdetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: accountSeq
    })
  });

  fetchDataPromise(req, 'getAccountDetail', resolve, reject);
}

export const removeAccount = (resolve, reject, token, accountSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/deleteaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: accountSeq
    })
  });

  fetchDataPromise(req, 'removeAccount', resolve, reject);
}

export const addAccount = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/addaccount', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'addAccount', resolve, reject);
}

export const editAccount = (resolve, reject, token, reqBodyObj) => {
    let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/editaccount', {
      method: 'POST',
      mode: 'cors',
      headers: {
        'Authorization' : token,
        'Content-Type' : 'application/json'
      },
      body: JSON.stringify(reqBodyObj)
    });

    fetchDataPromise(req, 'editAccount', resolve, reject);
}

// account role data
export const getRoleList = (resolve, reject, token, orgSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/getroles', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      organizationId: orgSeq
    })
  });

  fetchDataPromise(req, 'getRoleList', resolve, reject);
}

export const getRoleDetail = (resolve, reject, token, roleSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/getroledetail', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: roleSeq
    })
  });

  fetchDataPromise(req, 'getRoleDetail', resolve, reject);
}

export const removeRole = (resolve, reject, token, roleSeq) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/deleterole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      seq: roleSeq
    })
  });

  fetchDataPromise(req, 'removeRole', resolve, reject);
}

export const addRole = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/addrole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'addRole', resolve, reject);
}

export const editRole = (resolve, reject, token, reqBodyObj) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['role'] + '/editrole', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify(reqBodyObj)
  });

  fetchDataPromise(req, 'editRole', resolve, reject);
}

export const getNotify = (resolve, reject, site, token) => {
  let req = new Request(window.CONFIG.SWS_SERVER_API_URI + window.CONFIG.SWS_SERVER['account'] + '/notify/getnotify', {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Authorization' : token,
      'Content-Type' : 'application/json'
    },
    body: JSON.stringify({
      organizationId: site
    })
  });

  fetchDataPromise(req, 'getNotify', resolve, reject);
}